import axios, { AxiosPromise } from 'axios';
import { OnRequestSuccess, OnRequestError } from '../services/Responses';
import { ShowLoginModal } from '../components/Layout/GlobalLoginModal';

export class AbstractApiService {
    protected HttpGet(url: string): AxiosPromise<any> {
        return axios.get('./' + url, this.GetConfig());
    }

    protected HttpPost(url: string, data: any): AxiosPromise<any> {
        return axios.post('./' + url, JSON.stringify(data), this.GetConfig());
    }

    protected Get(url: string, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.HttpGet(url).then(res => {
            onSuccess(res);
        }).catch(error => {
            if (error.response) {
                if (error.response.status === 401) {
                    ShowLoginModal();
                }
            }
            onError(error);
        });
    }

    protected Post(url: string, data: any, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.HttpPost(url, data).then(res => {
            onSuccess(res);
        }).catch(error => {
            if (error.response) {
                if (error.response.status === 401) {
                    ShowLoginModal();
                }
            }
            onError(error);
        });
    }

    private GetConfig(): any {
        let config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        return config;
    }
}


// WEBPACK FOOTER //
// ./src/abstractions/AbstractApiService.tsx